export interface CountryCode {
  id: number;
  name: string;
  prefixCode: string;
  nameEN: string;
  regex: string;
  ioS2: string;
}
